import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Replace } from './Interfaces/replacements';
import { RespBase, ObjType } from './Interfaces/resp-base';
import { StatesComponents } from './Interfaces/states-component';
import { ModalBaseConocimientoComponent } from './modal-base-conocimiento/modal-base-conocimiento.component';

@Injectable({
  providedIn: 'root'
})

export class KnowledgeBaseLibService {

  protected messageError: string = 'Cargando base de conocimiento...';
  protected responseKnowledgeBase = {} as RespBase;
  protected listScripts: ObjType[] = [];
  public confirmKnowledge: boolean = false;
  public statesComponents = {
    btnCancel: true,
    btnConfirm: true,
    titleScript: true,
  } as StatesComponents;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
  ) { }

  private postKnowledgeBase(url: string) {
    return this.http.post(url, null);
  }

  /**
   * Su uso es para consultar los guiones de la funcionalidad socilitada.
   * @author Elkin Omar Jiménez García <jimenezelkg@globalhitss.com>
   * @param url URL a la que se consultará la base de conocimiento.
   * @param showModal Enviar valor en true si se desea abrir el modal al realizar la consulta exitosa.
   * @param replacements Arreglo de llaves y valores a reemplazar en los guiones: [{key: 'key1', value: 'value1'},{key: 'key2', value: 'value2'}]
   */
  public fetchKnowledgeBase(url: string, showModal?: boolean, replacements?: Replace[]): void {
    try {
      this.postKnowledgeBase(url).subscribe(
        data => {
          console.log('BASE DE CONOCIMIENTO: ', data);
          this.responseKnowledgeBase = data as RespBase;
          if (this.responseKnowledgeBase.State.toLowerCase() == 'ok') {
            this.listScripts = this.responseKnowledgeBase.ObjType;
            if (replacements) {
              this.replaceInScript(replacements);
            }
            this.confirmKnowledge = true;
          } else {
            this.confirmKnowledge = false;
            this.messageError = 'No se encontraron guiones de base de conocimiento para la funcionalidad solicitada. Por favor intente de nuevo.';
            this.listScripts = [];
          }
          if (showModal) {
            this.openKnowledgeBaseModal();
          }
        }, error => {
          console.log('ERROR | BASE DE CONOCIMIENTO WS: ', error);
          this.messageError = 'No se logró traer los guiones de base de conocimiento para la funcionalidad solicitada. Por favor intente de nuevo.';
          this.confirmKnowledge = false;
          this.listScripts.push({});
          const dialogRef = this.dialog.open(ModalBaseConocimientoComponent, {
            disableClose: true,
            autoFocus: false,
          });
        }
      );
    } catch (error) {
      console.log('ERROR | BASE DE CONOCIMIENTO CATCH: ', error);
      this.messageError = 'No se logró traer los guiones de base de conocimiento para la funcionalidad solicitada. Por favor intente de nuevo.';
      this.confirmKnowledge = false;
      this.listScripts.push({});
      const dialogRef = this.dialog.open(ModalBaseConocimientoComponent, {
        disableClose: true,
        autoFocus: false,
      });
    }
  }

  /**
  * Abrir el modal de base de conocimiento
  * @author Elkin Omar Jiménez García <jimenezelkg@globalhitss.com>
  */
  public openKnowledgeBaseModal(states?: StatesComponents) {
    if (states) {
      this.statesComponents.btnCancel = states.btnCancel == false ? states.btnCancel : true;
      this.statesComponents.btnConfirm = states.btnConfirm == false ? states.btnConfirm : true;
      this.statesComponents.titleScript = states.titleScript == false ? states.titleScript : true;
    }
    return new Promise<boolean>((resolve, reject) => {
      try {
        const dialogRef = this.dialog.open(ModalBaseConocimientoComponent, {
          disableClose: true,
          autoFocus: false,
        });
        dialogRef.afterClosed().subscribe(result => {
          // console.log(`Respuesta base de conocimiento: ${result}`);
          resolve(result);
        });
        if (!(this.listScripts.length > 0)) {
          this.confirmKnowledge = false;
          this.messageError = 'No se han consultado correctamente los guiones de base de conocimiento. Por favor revise la documentación de la librería e intente de nuevo.';
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
  * Consulta por nombre del guión.
  * @author Elkin Omar Jiménez García <jimenezelkg@globalhitss.com>
  * @param nameScript Nombre del guión por el cual se desea filtrar.
  * @param replacements Arreglo de llaves y valores a reemplazar en los guiones: [{key: 'key1', value: 'value1'},{key: 'key2', value: 'value2'}]
  */
  public searchByNameScript(nameScript: string, replacements?: Replace[]): void {
    const guiones = this.responseKnowledgeBase.ObjType.filter(
      guion => guion.NAME_KNOWLEDGE.toLowerCase().replace(/ /g, '').indexOf(nameScript.toLowerCase().replace(/ /g, '')) != -1
    )
    if (guiones.length > 0) {
      this.listScripts = guiones;
      if (replacements) {
        this.replaceInScript(replacements);
      }
      this.confirmKnowledge = true;
      console.log('Solo el guión: ', this.listScripts);
    } else {
      this.confirmKnowledge = false;
      this.messageError = 'No se encontraron guiones con el nombre de: ' + nameScript.toLowerCase() + '.';
    }
  }

  /**
  * Consulta por ID del guión.
  * @author Elkin Omar Jiménez García <jimenezelkg@globalhitss.com>
  * @param IdScript ID del guión por el cual se desea filtrar.
  * @param replacements Arreglo de llaves y valores a reemplazar en los guiones: [{key: 'key1', value: 'value1'},{key: 'key2', value: 'value2'}]
  */
  public searchByIdScript(IdScript: number, replacements?: Replace[]): void {
    const guiones = this.responseKnowledgeBase.ObjType.filter(
      guion => guion.ID_KNOWLEDGE_BASE == IdScript
    )
    if (guiones.length > 0) {
      this.listScripts = guiones;
      if (replacements) {
        this.replaceInScript(replacements);
      }
      this.confirmKnowledge = true;
      console.log('Solo el guión: ', this.listScripts);
    } else {
      this.confirmKnowledge = false;
      this.messageError = 'No se encontraron guiones con el ID a consultar.';
    }
  }

  /**
  * Devuelve los guiones al total de guiones consultados originalmente para el flujo.
  * @author Elkin Omar Jiménez García <jimenezelkg@globalhitss.com>
  */
  public resetListScripts() {
    this.listScripts = this.responseKnowledgeBase.ObjType;
    if (this.listScripts.length > 0) {
      this.confirmKnowledge = true;
      console.log('Guiones reiniciados...');
    } else {
      this.confirmKnowledge = false;
      this.messageError = 'No se encontraron guiones de base de conocimiento para la funcionalidad solicitada.';
      this.openKnowledgeBaseModal();
    }
  }

  private replaceInScript(replaces: Replace[]) {
    replaces.forEach(replace => {
      this.listScripts.forEach(script => {
        script.VALUE_KNOWLEDGE = script.VALUE_KNOWLEDGE.split(replace.key).join(replace.value);
      })
    })
  }

}